<script>
    import { onMount } from "svelte";
    import Presets from "../../Pages/Presets/Presets.svelte";
    import { checkTokenExpiration } from "../../Utils/utilFunctions.svelte";
    import { user } from "../../stores";

    export let params = {};
    export let tokenRefresh = undefined;

    onMount(async () => {
        tokenRefresh = checkTokenExpiration();

        if (!params.hasOwnProperty("id")) params.id = $user.id;
    });
</script>

{#await tokenRefresh then tokenRefreshResult}
    {#if tokenRefreshResult === "valid" || tokenRefreshResult === "refreshed"}
        <div class="flex flex-1 flex-col w-full px-6 py-4 bg-gray-200">
            <Presets {params} />
        </div>
    {/if}
{/await}
